import image from "../../assets/instagram-logo.svg";
import "./FooterComponent.scss";

export function FooterComponent() {
  return (
    <div
      className="instagram-footer d-flex justify-content-center align-items-center"
      onClick={() => window.open("https://www.instagram.com/celenora.official")}
    >
      <img className="instagram-logo mouse-hover" src={image} />
      <div className="instagram-text mouse-hover">celenora.official</div>
    </div>
  );
}
